module.exports = __webpack_public_path__ + "static/kelsie-5-1063f52ef90e12ae9e14d46314edda00.jpg";